import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Popover/popover';
import { css } from '@patternfly/react-styles';
export var PopoverBody = function PopoverBody(_a) {
  var children = _a.children,
      id = _a.id,
      props = __rest(_a, ["children", "id"]);

  return React.createElement("div", Object.assign({
    className: css(styles.popoverBody),
    id: id
  }, props), children);
};